import { FileText, Mic, Image, Link2, CheckSquare } from "lucide-react";
import type { Note } from "../lib/api";

const typeIcons: Record<string, React.ReactNode> = {
  text: <FileText size={14} />,
  voice: <Mic size={14} />,
  photo: <Image size={14} />,
  link: <Link2 size={14} />,
  document: <FileText size={14} />,
};

interface Props {
  note: Note;
  onClick?: () => void;
}

export function NoteCard({ note, onClick }: Props) {
  const date = new Date(note.created_at).toLocaleDateString("ru-RU", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <button
      onClick={onClick}
      className="w-full text-left bg-surface-card hover:bg-surface-elevated transition-colors rounded-xl p-4 border border-white/5"
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 text-accent-soft opacity-80">
          {typeIcons[note.type] || typeIcons.text}
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-white/90 line-clamp-2 leading-snug">
            {note.summary || note.content}
          </p>
          <div className="flex items-center gap-2 mt-2 text-xs text-white/40">
            <span>{date}</span>
            {note.is_task && (
              <span className="inline-flex items-center gap-1 text-accent-soft">
                <CheckSquare size={12} />
                задача
              </span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
}